module.exports = __webpack_public_path__ + "static/media/african-american-5041078_1280.8f43dc10.jpg";